import type React from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {ToastContainer as DsToastContainer} from 'pepsico-ds'
import type {RootState} from '@/store'
import {removeToast} from '@/store/slices/toastSlice'

const GlobalToastContainer: React.FC = () => {
  const dispatch = useDispatch()
  const toasts = useSelector((state: RootState) => state.toast.toasts)

  const handleRemoveToast = (id: number | undefined) => {
    if (id !== undefined) {
      dispatch(removeToast(String(id)))
    }
  }

  // Transform our toast format to match pepsico-ds format
  const transformedToasts = toasts.map(toast => ({
    id: parseInt(toast.id),
    type: toast.type,
    text: toast.message,
    duration: toast.duration || 4000,
  }))

  // Only render if there are toasts to show
  if (transformedToasts.length === 0) {
    return null
  }

  return (
    // z-index must exceed the design system modal's 3333 so toasts stay visible above open modals
    <div className="fixed bottom-20 left-1/3 z-[9999]">
      <DsToastContainer
        className="select-none"
        position="bottom-center"
        data={transformedToasts}
        removeToast={handleRemoveToast}
        showActionIcon
      />
    </div>
  )
}

export default GlobalToastContainer
